<div class="container-fluid">
  <form #invForm="ngForm" aimsAutoreorderDirective>
    <!-- Header -->
    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h3>{{title}}</h3>
      </div>

      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">
          <aims-common-button
            title="Clear"
            aria-label="Clear"
            (click)="clearWholeForm()" >
            <mat-icon color="primary">clear</mat-icon>
          </aims-common-button>

          <aims-common-button
            title="Save"
            aria-label="Save"
            [disabled]="!(invForm.form.valid && invForm.form.dirty)"
            (click)="saveInventoryItem(inventoryItem)" >
            <mat-icon color="primary">save</mat-icon>
          </aims-common-button>

          <aims-common-button
            title="Save & New"
            aria-label="Save & New"
            [disabled]="!(invForm.form.valid && invForm.form.dirty)"
            (click)="saveInventoryItemAndClear(inventoryItem)" >
            <mat-icon color="primary">save</mat-icon><span class="primary-text">*</span>
          </aims-common-button>

          <aims-common-button *ngIf="!newItem"
            title="Move..."
            aria-label="Move Inventory"
            [disabled]="!(invForm.form.valid)"
            (click)="moveInventoryItem(inventoryItem)" >
            <mat-icon color="primary">local_shipping</mat-icon>
          </aims-common-button>

          <aims-common-button *ngIf="!newItem"
            title="Create Req..."
            aria-label="Create Req"
            [disabled]="!(invForm.form.valid)"
            (click)="createReq()" >
            <mat-icon color="primary">build</mat-icon>
          </aims-common-button>

          <aims-common-button  *ngIf="!newItem" [matMenuTriggerFor]="matmenu"
              [disabled]="!(invForm.form.valid) || inventoryItem.barcode == null"
              attr.aria-label="Print Barcode" title="Print Barcode">
           <mat-icon color="primary">qr_code</mat-icon>
          </aims-common-button>
          <mat-menu #matmenu="matMenu">
            <button mat-menu-item (click)="printBarcode2x4()"> <span>2x4</span> </button>
            <button mat-menu-item (click)="printBarcode1x2()"> <span>1x2</span> </button>
            <button mat-menu-item (click)="printBarcode075x2()"> <span>0.75x2</span> </button>
            <button mat-menu-item (click)="printBarcode05x15()"> <span>0.5x1.5</span> </button>
            <button mat-menu-item (click)="printBarcode375x2()"> <span>0.375x2</span> </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <hr style="margin-top: 2px; margin-bottom: 12px" />

    <aims-form [cols]="1" [spaceRows]="true">
      <aims-fc [labelColSize]="2" [controlColSize]="2">
        <ng-container *ngIf="!newItem">
          <mat-form-field appearance="fill" >
            <input matInput
            type="text"
              #barcode
              #aimsControl="ngModel"
              name="Inventory Item #"
              id="barcode"
              [(ngModel)]="inventoryItem.barcode"
              (input)="onValueChange($event)"
              [minlength]="inventoryConfig?.inventoryItemNumberLength"
              [maxlength]="inventoryConfig?.inventoryItemNumberLength"
              required >
          </mat-form-field>
        </ng-container>
      </aims-fc>
    </aims-form>

    <aims-form [editable]="true" [cols]="1" [spaceRows]="true">
      <aims-fc [labelColSize]="2" [controlColSize]="6">
        <mat-form-field appearance="fill">
        <input
          matInput
          #aimsControl="ngModel"
          id="description"
          type="text"
          name="Description"
          [(ngModel)]="inventoryItem.description"
          required />
        </mat-form-field>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="4">
        <mat-form-field appearance="fill">
          <input
            matInput
            #aimsControl="ngModel"
            id="partNo"
            type="text"
            name="Part #"
            [(ngModel)]="inventoryItem.partNo"
            maxLength="40" />
        </mat-form-field>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="4">
        <mat-form-field appearance="fill">
          <input
            matInput
            #aimsControl="ngModel"
            id="currQuantity"
            type="text"
            name="Quantity"
            [(ngModel)]="currentQuantity"
            readonly
            maxLength="10" />
        </mat-form-field>
      </aims-fc>
    </aims-form>

    <ng-container *ngIf="!newItem">
      <div class="container-fluid" class="top20">
       <aims-form [cols]="2" [spaceRows]="true">
        <aims-fc  [showDescendants]="false" >

        <aims-form [header]="'Inventory Received'" [cols]="1" [spaceRows]="true" *ngIf="permissions.canCreate(permissions.ComponentID.InventoryReceipt)">
          <aims-fc
              [labelColSize]="2"
              [controlColSize]="4"
              [editable]="!inventoryItem.assemblyIssued" >
            <mat-form-field appearance="fill">
              <input matInput
                type="number"
                #aimsControl="ngModel"
                name="Rec Quantity"
                id="quantity"
                [min]="0"
                [max]="100000"
                [(ngModel)]="inventoryItemReceived.quantity"
                required >
            </mat-form-field>
          </aims-fc>
          <aims-fc [labelColSize]="2" [controlColSize]="4">
            <mat-form-field appearance="fill">
              <input matInput class="no-spinners"
                type="number"
                #aimsControl="ngModel"
                name="Cost Per Unit"
                id="Cost"
                [(ngModel)]="inventoryItemReceived.costPerUnit"
                [min]="0.0000"
                required >
            </mat-form-field>
          </aims-fc>
        </aims-form>
        </aims-fc>

        <aims-fc [showDescendants]="false">
          <aims-form [header]="'Manual Expenditure'" [cols]="1" [spaceRows]="true">
            <aims-fc
              [labelColSize]="2"
              [controlColSize]="4"
              [editable]="!newItem" >
              <mat-form-field appearance="fill">
                <input matInput
                  type="number"
                  #aimsControl="ngModel"
                  name="Exp Quantity"
                  id="quantity"
                  [min]="0"
                  [max]="100000"
                  [(ngModel)]="expendedInventoryItemQuantity"
                  required >
              </mat-form-field>
            </aims-fc>

            <aims-fc [labelColSize]="2" [controlColSize]="8">
              <mat-form-field appearance="fill">
                <textarea matInput
                  #aimsControl="ngModel"
                  name="Exp Note"
                  placeholder="Note"
                  [(ngModel)]="expendedInventoryItemNote"
                  maxlength="240"
                ></textarea>
              </mat-form-field>
              </aims-fc>
            </aims-form>

          </aims-fc>
        </aims-form>
    </div>
  </ng-container>
  <ng-container *ngIf="showAssemblyAlreadyReceived()">
    <div><h3>This Assembly has already been received into inventory.</h3></div>
  </ng-container>


    <aims-form [editable]="true" [cols]="1" [spaceRows]="true" [hider]="true" header="Details">
      <aims-fc [labelColSize]="2" [controlColSize]="1">
          <mat-checkbox
            #aimsControl="ngModel"
            name="Active"
            [(ngModel)]="inventoryItem.isActive">
            </mat-checkbox>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
          <mat-checkbox
            #aimsControl="ngModel"
            name="Assembly Issued"
            [(ngModel)]="inventoryItem.assemblyIssued"
            (change)="onAssyIssuedChange($event)"
             >
            </mat-checkbox>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-checkbox
          #aimsControl="ngModel"
          name="Hazmat"
          [(ngModel)]="inventoryItem.hazmat" >
        </mat-checkbox>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-checkbox
          #aimsControl="ngModel"
          name="DIFM"
          [(ngModel)]="inventoryItem.difm" >
        </mat-checkbox>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-checkbox
          #aimsControl="ngModel"
          name="Work Order Req"
          [(ngModel)]="inventoryItem.workOrderRequired" >
        </mat-checkbox>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-checkbox
          #aimsControl="ngModel"
          name="Mission Critical"
          [(ngModel)]="inventoryItem.missionCritical" >
        </mat-checkbox>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-checkbox
          #aimsControl="ngModel"
          name="Govt Furnished"
          [(ngModel)]="inventoryItem.govtFurnished" >
        </mat-checkbox>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-checkbox
          #aimsControl="ngModel"
          name="Return To Govt"
          [(ngModel)]="inventoryItem.returnToGovt" >
        </mat-checkbox>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-checkbox
          #aimsControl="ngModel"
          name="Auto-Reorder"
          id="autoreorder"
          [(ngModel)]="inventoryItem.autoReorder" >
        </mat-checkbox>
      </aims-fc>

      <div *ngIf="invForm.errors?.['autoreorder'] && (invForm.touched || invForm.dirty)" class="alert alert-danger">
          If Auto-Reorder is on, Minimum Quantity and Authorized Quantity must be greater than zero.
      </div>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-form-field appearance="fill">
        <input matInput type="number"
                          class="fullWidth"
            #aimsControl="ngModel"
            name="Minimum Quantity"
            id="minquantity"
            [min]="0"
            [max]="1000000"
            [(ngModel)]="inventoryItem.minQty"
            >
        </mat-form-field>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-form-field appearance="fill">
        <input matInput type="number"
            #aimsControl="ngModel"
            name="Authorized Quantity"
            id="authquantity"
            [min]="0"
            [max]="100000"
            [(ngModel)]="inventoryItem.authorizedQty"
            >
        </mat-form-field>
      </aims-fc>
      <aims-fc [labelColSize]="2" [controlColSize]="3">
        <mat-form-field appearance="fill">
          <mat-select
            #aimsControl="ngModel"
            name="Site"
            [(ngModel)]="inventoryItem.siteId"
            (selectionChange)="siteChange($event)"
            required>
              <mat-option *ngFor="let s of sites | async" [value]="s.siteId">
                  {{ s.siteName }}
              </mat-option>
          </mat-select>
        </mat-form-field>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="3">
         <aims-lookup
            #aimsControl="ngModel"
            name="Location"
            [gridText]="'Select a Location'"
            [values]="locations | async"
            [idPropertyName]="'locationId'"
            [displayPropertyName]="'location'"
            [columnsInGrid]="locationColumns"
            (valueChange)="locationChange($event)"
            [(ngModel)]="inventoryItem.locationId">
        </aims-lookup>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="3">
        <aims-lookup
                #aimsControl="ngModel"
                name="Sub-Location"
                [gridText]="'Select a Sub-Location'"
                [values]="sublocations | async"
                [idPropertyName]="'subLocationId'"
                [displayPropertyName]="'subLocation'"
                [columnsInGrid]="sublocationColumns"
                [(ngModel)]="inventoryItem.subLocationId">
            </aims-lookup>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="1">
        <mat-form-field appearance="fill">
        <mat-select
          #aimsControl="ngModel"
          name="UI"
          [(ngModel)]="inventoryItem.unitOfIssueId"
          required>
            <mat-option *ngFor="let u of activeUnitValues| async" [value]="u.ui">
                {{ u.uiPlusDesc }}
            </mat-option>
        </mat-select>
        </mat-form-field>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="2">
        <mat-form-field appearance="fill">
        <mat-select
          #aimsControl="ngModel"
          name="Group"
          [(ngModel)]="inventoryItem.inventoryGroupId"
          >
            <mat-option *ngFor="let ig of activeInventoryGroups| async" [value]="ig.inventoryGroupId">
                {{ ig.inventoryGroupCode }} - {{ig.inventoryGroup}}
            </mat-option>
        </mat-select>
        </mat-form-field>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="2">

        <mat-form-field appearance="fill">
          <mat-select #aimsControl="ngModel"
            name="Owner"
            [(ngModel)]="inventoryItem.ownerId"
          >
            <mat-option *ngFor="let o of activeOwners | async" [value]="o.equipmentOwnerId">
              {{ o.equipmentOwner }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="2">
        <mat-form-field appearance="fill">
          <mat-select #aimsControl="ngModel"
            name="Work Section"
            [(ngModel)]="inventoryItem.workSectionId"
          >
            <mat-option *ngFor="let ws of workSections | async" [value]="ws.workSectionId">
              {{ ws.workSection }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="2">
         <aims-lookup
            #aimsControl="ngModel"
            name="Manufacturer"
            [gridText]="'Select a Manufacturer'"
            [values]="manufacturers | async"
            [idPropertyName]="'manufacturerId'"
            [displayPropertyName]="'manufacturer'"
            [columnsInGrid]="manfColumns"
            [(ngModel)]="inventoryItem.manufacturerId">
        </aims-lookup>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="2">
        <mat-form-field appearance="fill">
          <mat-select #aimsControl="ngModel"
            name="ERRC"
            [(ngModel)]="inventoryItem.errc"
          >
            <mat-option *ngFor="let e of errcCodes | async" [value]="e.errcDesig">
              {{ e.errcDesig }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="2">
          <mat-form-field appearance="fill">
            <mat-label></mat-label>
            <input
              name="Expiration Date"
              matInput
              #aimsControl="ngModel"
              [matDatepicker]="picker1"
              [(ngModel)]="inventoryItem.expirationDate"
            />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </aims-fc>

        <aims-fc [labelColSize]="2" [controlColSize]="2">
          <mat-form-field appearance="fill">
            <input matInput class="fullWidth" #aimsControl="ngModel" name="NSN"
                mask="0000-00-000-0000" [(ngModel)]="inventoryItem.nsn" />
          </mat-form-field>
        </aims-fc>

        <aims-fc [labelColSize]="2" [controlColSize]="2">
          <mat-form-field appearance="fill">
            <input matInput class="fullWidth" #aimsControl="ngModel" name="Serial Number" [(ngModel)]="inventoryItem.serialNo" />
          </mat-form-field>
        </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="5">
        <mat-form-field appearance="fill">
          <textarea matInput
            #aimsControl="ngModel"
            name="Note"
            placeholder="Notes"
            [(ngModel)]="inventoryItem.note"
            maxlength="240"
          ></textarea>
        </mat-form-field>
      </aims-fc>

    </aims-form>

      </form>
    <app-inventory-documents
      [documents]="documents"
      [attachedToId]="inventoryItem.inventoryItemId"
      [attachedToType]="'inventory'"
      (RowAdded)="loadInventoryItemDocuments()"
      (RowDeleted)="loadInventoryItemDocuments()"
    ></app-inventory-documents>


  <aims-spinner
    [spinnerText]="spinnerText"
    [showSpinner]="showSpinner"
  ></aims-spinner>
</div>
